import React from 'react';
import { Card, Descriptions, Tag, Spin, Button, Space, Avatar } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useBidvRefundBankDetail } from '../../hooks/useBidv';

const BidvDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { refundBank, loading } = useBidvRefundBankDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!refundBank) return <Card>Không tìm thấy refund bank.</Card>;

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/bidv-refund-banks')}>Quay lại</Button>
      <Card title={
        <Space>
          {refundBank.icon ? <Avatar src={refundBank.icon} shape="square" /> : <Avatar shape="square">{refundBank.code?.[0]}</Avatar>}
          {`BIDV refund bank · ${refundBank.name}`}
        </Space>
      }>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Tên">{refundBank.name}</Descriptions.Item>
          <Descriptions.Item label="Mã">{refundBank.code}</Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={refundBank.status === 1 ? 'success' : 'default'}>
              {refundBank.status === 1 ? 'Bật' : 'Tắt'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Thứ tự">{refundBank.ordering}</Descriptions.Item>
          <Descriptions.Item label="Tenant ID" span={2}><code>{refundBank.tenant_id || '—'}</code></Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {refundBank.created_at ? dayjs(refundBank.created_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Cập nhật">
            {refundBank.updated_at ? dayjs(refundBank.updated_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default BidvDetail;
export { BidvDetail };
